"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveCard = exports.Card = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var colors_1 = require("../../theme/colors");
function Card(_a) {
    var _b;
    var children = _a.children, borderColor = _a.borderColor, backgroundColor = _a.backgroundColor, _c = _a.hasShadow, hasShadow = _c === void 0 ? true : _c, _d = _a.overflow, overflow = _d === void 0 ? 'hidden' : _d, _e = _a.isRounded, isRounded = _e === void 0 ? true : _e, className = _a.className, rest = (0, tslib_1.__rest)(_a, ["children", "borderColor", "backgroundColor", "hasShadow", "overflow", "isRounded", "className"]);
    var classNames = (0, classnames_1.default)((_b = { hasShadow: hasShadow }, _b["".concat(className)] = className, _b));
    return (React.createElement(StyledCard, (0, tslib_1.__assign)({ borderColor: borderColor, backgroundColor: backgroundColor, className: classNames, overflow: overflow, isRounded: isRounded }, rest), children));
}
exports.Card = Card;
var StyledCard = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  overflow: ", ";\n\n  &.hasShadow {\n    box-shadow: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  overflow: ", ";\n\n  &.hasShadow {\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor || 'white';
}, function (_a) {
    var borderColor = _a.borderColor;
    return borderColor || '#dbdbdb';
}, function (_a) {
    var isRounded = _a.isRounded;
    return (isRounded ? '4px' : '0px');
}, function (_a) {
    var overflow = _a.overflow;
    return overflow;
}, theme_1.shadows.card);
exports.InteractiveCard = (0, styled_components_1.default)(Card).attrs(function (props) { return ({
    tabIndex: 1,
    hasShadow: props.hasShadow || false,
}); })(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  &:focus,\n  &:active,\n  &:hover {\n    outline: none;\n    cursor: pointer;\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n  }\n"], ["\n  &:focus,\n  &:active,\n  &:hover {\n    outline: none;\n    cursor: pointer;\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n  }\n"])), colors_1.colors.brand[400], colors_1.colors.brand[100]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map